import React, { ChangeEvent, FC } from 'react';
import { ValueFieldProps } from '@sitecore-jss/sitecore-jss-react-forms/types';
import BaseTextField from '../baseTextField';

const LeadDocument: FC<ValueFieldProps> = (props) => {
  const formatCpfCnpj = (inputValue) => {
    const digits = inputValue.replace(/[^0-9]/g, '');
    if (digits.length <= 11) {
      return digits
        .replace(/(\d{3})(\d)/, '$1.$2')
        .replace(/(\d{3})(\d)/, '$1.$2')
        .replace(/(\d{3})(\d)/, '$1-$2')
        .replace(/(\d{3})(\d{1,2})$/, '$1-$2');
    } else {
      return digits
        .replace(/(\d{2})(\d)/, '$1.$2')
        .replace(/(\d{3})(\d)/, '$1.$2')
        .replace(/(\d{3})(\d{1,4})/, '$1/$2')
        .replace(/(\d{4})(\d{1,2})$/, '$1-$2');
    }
  };

  const handleChange = (event: ChangeEvent<HTMLInputElement>): void => {
    event.target.value = formatCpfCnpj(event.target.value);
  };

  const inputAttributes = {
    onInput: handleChange,
    maxLength: 18,
  };

  return <BaseTextField type="text" inputAttributes={inputAttributes} {...props} />;
};

export default LeadDocument;
